import React from 'react'
import Image from '@/components/base/image'
import { AsgLogoArchiveProps } from './types'
import { Column, Row } from '@/components/base/gridview'
import Anchor from '@/components/base/anchor'

const AsgLogoArchive: React.FunctionComponent<AsgLogoArchiveProps> = (
  props
) => {
  return (
    <Row className="brand-card-list" gutter="lg">
      {props.data.map((item, index) => (
        <Column
          key={index}
          xs={{ size: 12 }}
          sm={{ size: 6 }}
          lg={{ size: 4 }}
          xl={{ size: 4 }}
          className={'brand-card-item'}
        >
          <span className="title" style={{ marginBottom: 0 }}>
            {item.firmName}
          </span>
          <span className="title bottom">{item.title}</span>
          <span className="description">
            <div
              dangerouslySetInnerHTML={{
                __html: item.description,
              }}
            ></div>
          </span>
          <div className="link-wrapper">
            {item.links.map((link, index2) => (
              <Anchor key={index2} {...link} />
            ))}
          </div>
          <Image
            alt={item.title}
            {...item.image}
            // src={'https://via.placeholder.com/400x250'}
            style={{ borderRadius: '30px' }}
          />
        </Column>
      ))}
    </Row>
  )
}

export default AsgLogoArchive
